<template>
	<div class="alarm-name-manage-page page-layout">
		<gc-header headerData="alarmNameManage">
			<template #ops>
				<el-button type="primary" v-has="'monitor:run:sys-alarm-name:create'" @click="handleAdd">
					新增告警名称
				</el-button>
			</template>
		</gc-header>
		<div class="run-main">
			<div class="serach">
				<gc-custom-search keyWord="告警名称" width="320px" :search.sync="form.alarmName"></gc-custom-search>
				<div class="serach-ops">
					<el-button type="primary" v-click-blur @click="handleQuerySearch">查询</el-button>
					<el-button @click="handleQueryReset" v-click-blur>重置</el-button>
				</div>
			</div>
			<div class="table-show" v-loading="loading">
				<gc-table border :columns="columns" :table-data="tableData"></gc-table>
			</div>
		</div>
		<OperateAlarmNameModal v-if="modalVisible" :formValues="selectFormValues" @close-modal="handleCloseModal" />
	</div>
</template>

<script>
import { apiGetAlarmNameList, apiDeleteAlarmName } from '@/apis/alarm.api'
import OperateAlarmNameModal from './components/OperateAlarmNameModal'

export default {
	name: 'AlarmNameManage',
	components: { OperateAlarmNameModal },
	data() {
		return {
			form: {
				alarmName: null,
			},
			columns: [
				{
					key: 'alarmName',
					name: '告警名称',
					tooltip: true,
				},
				{
					key: 'createTime',
					name: '创建时间',
				},
				{
					key: 'oprate',
					name: '操作',
					sortDisable: true,
					width: 200,
					render: (h, row) => {
						return h(
							'div',
							null,
							[
								this.$has('monitor:run:sys-alarm-name:update')
									? h(
											'el-button',
											{
												props: { type: 'text', size: 'medium' },
												on: {
													click: () => this.handleEdit(row),
												},
											},
											'编辑',
									  )
									: null,
								this.$has('monitor:run:sys-alarm-name:delete')
									? h(
											'el-button',
											{
												style: { color: '#e5662e' },
												props: { type: 'text', size: 'medium' },
												on: {
													click: () => this.handleDelete(row),
												},
											},
											'删除',
									  )
									: null,
							].filter(Boolean),
						)
					},
				},
			],
			loading: false,
			tableData: [],
			modalVisible: false,
			selectFormValues: null,
		}
	},

	created() {
		this.queryTableDataPageList()
	},

	methods: {
		async queryTableDataPageList() {
			this.loading = true
			const searchParams = {
				alarmName: this.form.alarmName,
				tenantId: this.$store.getters.userInfo.tenantId,
			}
			try {
				this.tableData = await apiGetAlarmNameList(searchParams)
			} finally {
				this.loading = false
			}
		},

		handleAdd() {
			this.selectFormValues = null
			this.modalVisible = true
		},

		handleEdit(row) {
			this.selectFormValues = row
			this.modalVisible = true
		},

		async handleDelete(row) {
			await this.$confirm('你确定要删除该告警名称，删除后不可撤销，请确认！')
			await apiDeleteAlarmName(row.id)
			this.$message.success('删除成功')
			this.handleQueryReset()
		},

		handleQuerySearch() {
			this.queryTableDataPageList()
		},

		handleQueryReset() {
			for (const key in this.form) {
				this.form[key] = null
			}
			this.queryTableDataPageList()
		},

		handleCloseModal(refresh) {
			this.modalVisible = false
			if (refresh) {
				this.handleQueryReset()
			}
		},
	},
}
</script>

<style lang="scss" scoped>
@import '../run-manage/runLayout.scss';
</style>
